import { DefaultService } from '@/services/DefaultService';

export default class CockpitVendasService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getClientesPorVendedor(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-por-vendedor-12-meses`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesPorStatusComercialBarra(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-por-status-comercial-barra`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getTitulosVencidos(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/titulos-vencidos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getVisitaColaborador(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/visitas-colaborador`, filtros, this._headers)
        .then(res => res.body, this.handleError);
    }

    getTitulosAVencer(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/titulos-a-vencer`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getTitulosPorData(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/titulos-por-data`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesEmNaoRota(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-nao-rota`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesPorAtividade(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-por-atividade`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesPorStatusComercial(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-por-status-comercial`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesPorRegiao(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-regiao`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getMotivoNaoVenda(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/motivo-nao-venda`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getVendaAtendimentos(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/venda-atendimentos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesAtendimentos(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-atendimentos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    /*
        @85833 - dashboard visitas x empresa que mostra a quantidade de visitas feitas por cliente em cada empresa
    */
    getVisitasEmpresa(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/visitas-empresa`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getColaboradorVisitaPeriodoDia(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/colaborador-visita-periodo-do-dia`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveClientesComVendas(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/cliente-com-vendas`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }
    

    saveVendasPorPeriodo(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/vendas-por-periodo`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveClientesNovos(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-novos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveRotasCadastradas(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/rotas-cadastradas`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveClientesSemVendasPorVendedor(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-sem-venda-por-vendedor`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveClientesPorVendedor(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-por-vendedor`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveClientesPorFaturamento(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/clientes-por-faturamento`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveNaoVenda(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/nao-vendas`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveValorSimilarAgregado(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/valor-sim-agr`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getQtdProdutos(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/produtos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getEvolucaoVendas(filtros, mes, ano) {
        return this._http.post(`${this._env}/cockpit-sales/evolucao-vendas?mes=${mes}&ano=${ano}`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientePorCidade(filtros) {
        return this._http.post(`${this._env}/cockpit-sales/cliente-por-cidade`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    saveChartLayout(layout) {
        return this._http.post(`${this._env}/cockpits`, layout, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getChartLayout(tipo) {
        return this._http.get(`${this._env}/cockpits/${tipo}.json`, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getAll() {
        return this._http.get(`${this._env}/cockpit-sales/charts.json`, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getCharts(chart) {
        return this._http.post(`${this._env}/cockpit-sales/chart.json`, chart, this._headers)
            .then(res => res.body, err => this.handleError(err));
    }

    getChartByTitulo(titulo, filters) {
        return this._http.post(`${this._env}/cockpit-sales/chart/${titulo}`, filters, this._headers)
            .then(res => res.body, err => this.handleError(err));
    }

    delete(id) {
        return this._http.delete(`${this._env}/cockpit-sales/delete-chart/${id}`, this._headers)
            .then(res => res.body, err => this.handleError(err));
    }
}